import React, {Component} from 'react';

import SpecialPricingForm from '../../../shared/components/SpecialPricingForm';

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_QA_COST,
  ADJOY_DEFAULT_PUZZLE_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT
} from '../../../config';

class AccountSpecialPricing extends Component {
  constructor(){
    super();

    this.state = {
      updating:false,
      propagate:false,
      error:null
    };
  }

  handleSubmit(data){
    this.setState({updating:true});

    console.log('SENDING DATA',data);

    if(data.useCostPerCompletion){
      this.props.updateAgency(this.props.accountId,{
        useCostPerCompletion:true,
        defaultRevenueSplit:data.revenueSplit,
        defaultCostPerCompletion:data.defaultCostPerCompletion,
        propagateCostChanges:data.propagateCostChanges
      })
        .then(() => this.setState({updating:false}))
        .catch((err) => this.setState({error:err}));

    } else {
      this.props.updateAgency(this.props.accountId,{
        useCostPerCompletion:false,
        chooseDefaultCost:data.chooseDefaultCost,
        defaultRevenueSplit:data.revenueSplit,
        ratableDefaultCost:data.ratableDefaultCost,
        thisOrThatDefaultCost:data.thisOrThatDefaultCost,
        qaDefaultCost:data.qaDefaultCost,
        puzzleDefaultCost:data.puzzleDefaultCost,
        propagateCostChanges:data.propagateCostChanges
      })
        .then(() => this.setState({updating:false}))
        .catch((err) => this.setState({error:err}));
    }
  }

  render(){
    const {
      defaultRevenueSplit,
      chooseDefaultCost,
      thisOrThatDefaultCost,
      ratableDefaultCost,
      qaDefaultCost,
      puzzleDefaultCost,
      defaultCostPerCompletion,
      useCostPerCompletion
    } = this.props;

    const { updating } = this.state;

    return (
      <div>
        <SpecialPricingForm
          forceUpdate
          allowPropagation
          propagationCheckboxText='Apply changes to existing brands'
          updateButtonText={updating ? 'Updating Account': 'Update Account'}
          defaultRevenueSplit={defaultRevenueSplit}
          defaultDefaultRevenueSplit={ADJOY_DEFAULT_REVENUE_SPLIT}
          chooseDefaultCost={chooseDefaultCost}
          defaultChooseDefaultCost={ADJOY_DEFAULT_CHOOSE_COST}
          thisOrThatDefaultCost={thisOrThatDefaultCost}
          defaultThisOrThatDefaultCost={ADJOY_DEFAULT_THIS_OR_THAT_COST}
          ratableDefaultCost={ratableDefaultCost}
          defaultRatableDefaultCost={ADJOY_DEFAULT_RATABLE_COST}
          qaDefaultCost={qaDefaultCost}
          defaultQADefaultCost={ADJOY_DEFAULT_QA_COST}
          puzzleDefaultCost={puzzleDefaultCost}
          defaultPuzzleDefaultCost={ADJOY_DEFAULT_PUZZLE_COST}
          defaultCostPerCompletion={defaultCostPerCompletion}
          useCostPerCompletion={useCostPerCompletion}
          onSubmit={(data) => this.handleSubmit(data)}
        />
        <br />
        <br />
      </div>
    )
  }
}

export default AccountSpecialPricing;



// WEBPACK FOOTER //
// ./src/routes/AccountSpecialPricing/components/AccountSpecialPricing.js